import {
    IntervalDataEntry,
    IntervalDisplayParam,
} from '@/hooks/useApi/useActiveManagementApi/types'
import { getEntryId } from '../../utils/getEntryId'

/**
 * Detects the data grouping mode based on the data structure.
 * - If all entries have the appropriate ID (meterId or subMeterId), the data is in 'compare' mode
 * - Otherwise, the data is in 'aggregate' mode
 *
 * @param data - Array of interval data entries
 * @param display - Display setting to use for ID extraction ('meters' or 'subMeters')
 * @returns 'compare' if all entries have the appropriate ID, 'aggregate' otherwise
 */
export const detectDataGrouping = (
    data: IntervalDataEntry[],
    display: IntervalDisplayParam
): 'aggregate' | 'compare' => {
    if (data.length === 0) {
        return 'aggregate'
    }

    // Check for specific ID based on display setting
    return data.every((entry) => getEntryId(entry, display) !== undefined)
        ? 'compare'
        : 'aggregate'
}
